const HomePaths = {
    Home: "/",
}
export default HomePaths